import apiClient from './index';

export interface User {
  id: number;
  username: string;
  role: 'admin' | 'readonly';
  is_active: boolean;
  must_change_password: boolean;
  created_at: string;
  updated_at: string;
  last_login: string | null;
}

export interface CreateUserRequest {
  username: string;
  password: string;
  role: 'admin' | 'readonly';
}

export interface UpdateUserRequest {
  role?: 'admin' | 'readonly';
  is_active?: boolean;
}

export async function getUsers(): Promise<User[]> {
  const response = await apiClient.get<User[]>('/spex/plus/users');
  return response.data;
}

export async function createUser(data: CreateUserRequest): Promise<{ status: string; user: User }> {
  const response = await apiClient.post('/spex/plus/users', data);
  return response.data;
}

export async function updateUser(userId: number, data: UpdateUserRequest): Promise<{ status: string; user: User }> {
  const response = await apiClient.put(`/spex/plus/users/${userId}`, data);
  return response.data;
}

export async function deactivateUser(userId: number): Promise<{ status: string; message: string }> {
  const response = await apiClient.delete(`/spex/plus/users/${userId}`);
  return response.data;
}

export async function resetUserPassword(userId: number, newPassword: string): Promise<{ status: string; message: string }> {
  const response = await apiClient.put(`/spex/plus/users/${userId}/password`, { new_password: newPassword });
  return response.data;
}
